import { useCallback, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { CustomerRefundService } from '../../api/services/customerRefundService';
import { CustomerRefundDatagrid } from '../../components/DataGrid/CustomerRefundDatagrid/CustomerRefundDatagrid';
import { CustomerRefundMetrics } from '../../components/CustomerRefundMetrics';
import { setRefundRequests } from '../../store/Reducers/CustomerRefundSlice';
import { showNotification } from '../../store/Reducers/NotificationSnackbarSlice';
import { IRootState } from '../../types/store';

export const CustomerRefundRequestPage = () => {
  const dispatch = useDispatch();
  const { content } = useSelector((state: IRootState) => state.customerRefund);

  const retrieveRefundRequests = useCallback(async () => {
    try {
      const res = await CustomerRefundService.getAllRefundRequests();
      dispatch(setRefundRequests(res));
    } catch (e: any) {
      dispatch(
        showNotification({
          message: `Failed to retrieve refund requests. ${e?.response?.data || ''}`,
          severity: 'error',
        }),
      );
    }
  }, [dispatch]);

  useEffect(() => {
    retrieveRefundRequests();
  }, [retrieveRefundRequests]);

  return (
    <>
      <CustomerRefundMetrics data={content} />
      <CustomerRefundDatagrid reload={retrieveRefundRequests} />
    </>
  );
};
